import { useEffect, useState } from "react";
import {
Container,
  Box,
  Typography,
  TextField,
  Button, Stack, CircularProgress
} from "@mui/material";
import { useParams } from "react-router-dom";
import ticketApi from "../../api/ticketApi";

export default function TicketDetail() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [ticket, setTicket] = useState(null);
  const [message, setMessage] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]); // ✅ AGGIUNTO

  useEffect(() => {
    loadTicket();
  }, [id]);

  const loadTicket = async () => {
    setLoading(true);
    const res = await ticketApi.get(id);
    setTicket(res.data);
    setLoading(false);
  };

  const handleFileChange = (e) => {
    setSelectedFiles(Array.from(e.target.files));
  };

  const handleAddMessage = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("message", message);

    selectedFiles.forEach(file => {
      formData.append("files", file);
    });

    await ticketApi.addMessage(id, formData);
    console.log("messaggio caricato");
    setMessage("");
    setSelectedFiles([]);
    setLoading(false);
    loadTicket();
  };

  const handleDownload = async (ticketId, attachment) => {
    const response = await ticketApi.downloadAttachment(
      ticketId,
      attachment.id
    );

    const blob = new Blob([response.data], {
      type: attachment.mimeType || "application/octet-stream"
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", attachment.filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  if (!ticket) return null;

  return (
  <Container>
    {loading && <Box sx={{ position: 'fixed', inset: 0, bgcolor: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300 }}><CircularProgress size={48}/></Box>}
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">
        Ticket #{ticket.id}
      </Typography>

      <Typography sx={{ mt: 2 }}>
        {ticket.description}
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h6">Messaggi</Typography>

        {ticket.messages?.map((m) => (
          <Box key={m.id} sx={{ mb: 2 }}>
            <Typography>
              [{m.authorType}] {m.message}
            </Typography>

            {m.attachments?.map((a) => (
              <Button
                key={a.id}
                size="small"
                onClick={() => handleDownload(ticket.id, a)}
                sx={{ display: "block", mt: 0.5 }}
              >
                {a.filename}
              </Button>
            ))}
          </Box>
        ))}
      </Box>

      <Box sx={{ mt: 4 }}>
        <TextField
          fullWidth
          multiline
          rows={3}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

      {/* UPLOAD FILE MULTIPLI */}
      <Stack direction="row" spacing={1}>
        <input
          type="file"
          multiple
          style={{ display: 'none' }}
          id="chat-file-upload"
          onChange={(e) => {
            const newFiles = Array.from(e.target.files);
            setSelectedFiles(prev => [...prev, ...newFiles]); // Accoda i file
          }}
        />
        <label htmlFor="chat-file-upload">
          <Button variant="outlined" component="span">
            {selectedFiles.length > 0
              ? `${selectedFiles.length} file selezionati`
              : 'Carica file'}
          </Button>
        </label>
        {selectedFiles.length > 0 && (
          <Stack spacing={0.5} sx={{ ml: 1 }}>
            {selectedFiles.map((file, index) => (
                <Stack key={index} direction="row" alignItems="center" spacing={0.5}>
                  <Typography variant="caption">{file.name}</Typography>
                  <Button
                    size="small"
                    color="error"
                    onClick={() => {
                      setSelectedFiles(prev => prev.filter((_, i) => i !== index));
                    }}
                  >
                    ✕
                  </Button>
                </Stack>
            ))}
          </Stack>
        )}
      </Stack>

        <Button
          variant="contained"
          sx={{ mt: 2, ml: 2 }}
          onClick={handleAddMessage}
        >
          Invia messaggio
        </Button>
      </Box>
    </Box>
        </Container>
  );
}